module.exports = __webpack_public_path__ + "static/media/booking-not-delivered.13c68be1.svg";